<template>
  <div>
    <filtro-cadu v-model="valueData" @limparFiltro="limparFiltro()" @filtrar="filtrar()">
      <div slot="body" class="mx-5" style="height: 420px">
        <v-row>
          <v-col cols="auto">
            <div class="fontColor1--text font-weight-bold">FILTRAR USUÁRIO</div>
          </v-col>
        </v-row>
        <ValidationObserver ref="observer">
          <v-row>
            <v-col cols="12">
              <autocomplete-cadu
                :items="listaUnimed.map((el) => el.textoExibicao)"
                :disabled="desabilitarAutocompleteUnimed"
                placeholder
                title="Unimed"
                v-model="unimedSelecionada.nome"
                @index="indexUnimed"
              />
            </v-col>
            <v-col cols="12">
              <input-cadu
                placeholder
                title="Nome do colaborador"
                v-model="colaboradorSelecionado"
                :onlyUpperCase="false"
                :max="'150'"
              />
            </v-col>
            <v-col cols="12">
              <input-cadu
                placeholder
                title="Login"
                v-model="loginSelecionado"
                :onlyUpperCase="false"
                :max="'50'"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <autocomplete-cadu
                :items="listaPerfil.map((el) => el.descricao)"
                placeholder
                title="Perfil de acesso"
                v-model="perfilSelecionado.nome"
                @index="indexPerfil"
              />
            </v-col>
          </v-row>
        </ValidationObserver>
      </div>
    </filtro-cadu>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import jwtDecode from 'jwt-decode'

import ListarUnimed from '@/services/Unimed/ListarUnimed'
import GerenciamentoUsuarios from '@/services/GerenciamentoUsuarios/GerenciamentoUsuarios'

export default {
  components: {
    ValidationObserver
  },

  props: {
    value: {
      type: Boolean,
      required: false
    },
    items: {
      type: Array,
      required: false
    },
    unimedId: {
      required: true,
      default: null
    },
    unimedNome: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      valueData: this.value,
      role: '',

      desabilitarAutocompleteUnimed: false,

      // Models Autocomplete
      unimedSelecionada: {
        nome: this.unimedNome,
        id: this.unimedId
      },
      colaboradorSelecionado: '',
      loginSelecionado: '',
      perfilSelecionado: {
        nome: '',
        id: ''
      },

      // Lista dos autompletes
      listaUnimed: [],
      listaColaboradores: [],
      listaPerfil: [],
      tokenBearer: localStorage.getItem('tokenBearer')
    }
  },

  async beforeMount () {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    this.role = jwtDecode(this.tokenBearer).role

    await this.loadingAll()
    this.isDirigente()
  },
  methods: {
    async loadingAll () {
      await this.getUnimeds()
      await this.getPapeis()
    },
    isDirigente () {
      if (this.role !== 'admin_brasil') {
        this.desabilitarAutocompleteUnimed = true
      } else {
        this.desabilitarAutocompleteUnimed = false
      }
    },
    async getUnimeds () {
      let listarUnimed = new ListarUnimed(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseUnimed = await listarUnimed.getAll()
        this.listaUnimed = responseUnimed.data
      } catch (err) {
        console.error(err)
      }
    },
    async getPapeis () {
      let listaPapeis = new GerenciamentoUsuarios(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responsePapeis = await listaPapeis.getPapeis()
        this.listaPerfil = responsePapeis.data
      } catch (err) {
        console.error(err)
      }
    },
    limparFiltro () {
      if (this.role === 'admin_brasil') {
        this.unimedSelecionada = {
          nome: '',
          id: ''
        }
      }
      this.loginSelecionado = ''
      this.colaboradorSelecionado = ''
      this.perfilSelecionado = {
        nome: '',
        id: ''
      }
    },
    filtrar () {
      const obj = {
        unimedId: this.unimedSelecionada.id,
        colaboradorSelecionado: this.colaboradorSelecionado,
        papelId: this.perfilSelecionado.id,
        login: this.loginSelecionado
      }
      this.$emit('filtrar', obj)
    },
    indexPerfil (index) {
      this.perfilSelecionado.id = (index > -1 && index != null) ? this.perfilSelecionado.id = this.listaPerfil[index].id : ''
    },
    indexUnimed (index) {
      this.unimedSelecionada.id = (index > -1 && index != null) ? this.unimedSelecionada.id = this.listaUnimed[index].id : ''
    }
  },

  watch: {
    valueData () {
      if (!this.valueData) {
        this.$emit('input', false)
      }
    },
    value () {
      this.valueData = this.value
    },
    unimedNome () {
      this.unimedSelecionada.nome = this.unimedNome
    }
  }
}
</script>
